// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BOSDates-module_range_dropdown_div_LMldO {
  width: 168px;
  flex-grow: 0;
}

.BOSDates-module_range_dropdown_kE1Qx {
  margin: 2px;
}

.BOSDates-module_range_input_v70aH input {
  width: 92px !important;
}

.BOSDates-module_date_input_xV62k {
  min-width: 80px;
}

.BOSDates-module_required_Fgyi9,
.BOSDates-module_required_Fgyi9 input::placeholder {
  color: var(--required-input);
}
`, "",{"version":3,"sources":["webpack://./src/client/components/Generic/BOSDateInput/BOSDates.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,4BAA4B;AAC9B","sourcesContent":[".range_dropdown_div {\n  width: 168px;\n  flex-grow: 0;\n}\n\n.range_dropdown {\n  margin: 2px;\n}\n\n.range_input input {\n  width: 92px !important;\n}\n\n.date_input {\n  min-width: 80px;\n}\n\n.required,\n.required input::placeholder {\n  color: var(--required-input);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"range_dropdown_div": `BOSDates-module_range_dropdown_div_LMldO`,
	"range_dropdown": `BOSDates-module_range_dropdown_kE1Qx`,
	"range_input": `BOSDates-module_range_input_v70aH`,
	"date_input": `BOSDates-module_date_input_xV62k`,
	"required": `BOSDates-module_required_Fgyi9`
};
export default ___CSS_LOADER_EXPORT___;
